import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AppInfoService} from '@enerbim/commons-lib';

@Component({
    selector: 'bim-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['footer.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {

    year: string;
    version: string;

    constructor(
        private appInfoService: AppInfoService,
    ) {
    }

    ngOnInit() {
        this.year = (new Date()).getFullYear().toString(10);
        this.version = environment.appVersion;
    }

    showAppInfo() {
        this.appInfoService.showAppInfo();
    }
}
